import "@irati/ui"
import routes from "./src/routes"

export default routes
